import { Component, OnInit, signal } from '@angular/core';

@Component({
  selector: 'lib-page-404',
  standalone: true,
  imports: [],
  templateUrl: './page-404.component.html',
  styleUrl: './page-404.component.scss'
})
export class Page404Component implements OnInit {
  public message = signal('');
  private messages = [
    `Ben alors, tu t'es perdu ?`,
    `C'est à ça que ressemble un échec crique en perception`,
    `J'ai cherché partout, il n'y a pas de promo ici`,
    `Je sais que tu aimes les promos, mais tu fouilles un peu trop`,
    `Comment tu es arrivé là ?`,
    `Tu le sais, tu n'a rien à faire ici. Clique sur le dé tout là haut, et je ne dirai rien à personne`,
  ]

  public ngOnInit(): void {
    this.setRandomMessage()
  }

  private setRandomMessage(): void {
    this.message.set(this.messages[this.getRandomInt(this.messages.length - 1)])
  }

  private getRandomInt(max: number): number {
    return Math.floor(Math.random() * (max + 1));
  }
}
